import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Carousel.css"; // Import CSS file
import slideone from "../Assets/Slider/Slide1.png";
import slidetwo from "../Assets/Slider/Slide2.png";
import slidethree from "../Assets/Slider/Slide3.png";
import sliderfour from "../Assets/Slider/Slider4.png";
import sliderfive from "../Assets/Slider/slider5.png";
import slidersix from "../Assets/Slider/slider6.png";

const images = [
  slideone,
  slidethree,
  sliderfour,
  slidetwo,
  slidersix,
  sliderfive,
];

export default function Carousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [index]);

  const nextSlide = () => {
    setIndex((prev) => (prev + 1) % images.length);
  };

  return (
    <div className="carousel-container">
      {/* Background Image with Wipe Effect */}
      <AnimatePresence mode="wait">
        <motion.img
          key={images[index]}
          src={images[index]}
          alt="Active Slide"
          className="carousel-image"
          style={{ position: "absolute", width: "100%" }} // Ensure overlap
          initial={{ x: "100%", opacity: 0 }} // Start off-screen
          animate={{ x: 0, opacity: 1 }} // Fade in while moving
          exit={{ x: "-100%", opacity: 0 }} // Reduce opacity while exiting
          transition={{ duration: 0.5, ease: "easeInOut" }}
        />
      </AnimatePresence>

      {/* Thumbnail Queue */}
      <div className="thumbnail-container">
        {images.map((img, i) => (
          <motion.img
            key={i}
            src={img}
            alt="Upcoming Slide"
            className={`thumbnail ${i === index ? "active-thumbnail" : ""}`}
            onClick={() => setIndex(i)}
            whileHover={{ scale: 1.05 }}
          />
        ))}
      </div>
    </div>
  );
}
